export const TESLIMAT_TUR = {
  HEMEN: 3,
  ILERI_TARIH: 6
}